import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing }) => ({
  root: {
    width: 480,
    padding: spacing(3),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    gap: spacing(2),
  },
  actions: {
    padding: 0,
  },
  subtitle: {
    marginTop: spacing(1),
  },
  title: {
    margin: 0,
    fontWeight: 500,
    marginTop: spacing(-2),
  },
}));

export default styles;
